export default __webpack_public_path__ + "static/media/img3.8c1d3e19.png";